


























import { defineComponent } from '@nuxtjs/composition-api'

import VueQrcode from 'vue-qrcode'

export default defineComponent({
  components: { VueQrcode },
  props: {
    pixCode: { type: String, required: true }
  },
  methods: {
    async onClick() {
      await (this as any).$copyText(this.pixCode, this.$refs.qrcode)
      this.showPopover = true
      const that = this
      setTimeout(() => (that.showPopover = false), 2000)
    }
  },
  data() {
    return {
      showPopover: false
    }
  }
})
